import { loadCoverages } from '../../parsers/payer.parser';
import { parseChiefComplaint } from '../../parsers/request.parser';

export const REQUEST_REFRESH_RESOURCE_APPLY = 'apply';
export const REQUEST_REFRESH_RESOURCE_NO_OP = 'no-op';
export const REQUEST_REFRESH_RESOURCE_CLEAR = 'clear';

const last = values => (values && values.length ? values[values.length - 1] : {});

const formatBillerVerifiedBy = request =>
  request?.billerVerifiedById && request?.billerVerifiedBy
    ? `${request.billerVerifiedBy.firstName} ${request.billerVerifiedBy.lastName}`
    : '';

export const readPatientFromRequest = request => {
  const demographics = last(request?.patient?.demographics);

  return {
    firstName: demographics.firstName,
    lastName: demographics.lastName,
    dob: demographics.dob,
    address1: demographics.address1,
    address2: demographics.address2,
    city: demographics.city,
    state: demographics.state,
    zip: demographics.zip,
  };
};

export const readPatientFromState = state => ({
  firstName: state.infobox.patientFirstName,
  lastName: state.infobox.patientLastName,
  dob: state.infobox.patientBirthday,
  address1: state.patient.address1,
  address2: state.patient.address2,
  city: state.patient.city,
  state: state.patient.state,
  zip: state.patient.zip,
});

export const getPatientInfoboxFields = request => {
  const patient = readPatientFromRequest(request);

  return {
    patientFirstName: patient.firstName,
    patientLastName: patient.lastName,
    patientBirthday: patient.dob || null,
  };
};

export const readCoveragesFromRequest = request =>
  request ? loadCoverages({ ...request, coverages: request.coverages || [] }) : {};

export const readCoveragesFromState = state => state.infobox.coverages || {};

export const readChiefComplaintFromRequest = request =>
  request ? parseChiefComplaint(request) : { chiefComplaintId: null, chiefComplaintName: '', chiefComplaintType: null };

export const readChiefComplaintFromState = state => ({
  chiefComplaintId: state.requests.chiefComplaintId,
  chiefComplaintName: state.requests.chiefComplaintName,
  chiefComplaintType: state.requests.chiefComplaintType,
});

export const readBilledToFacilityFromRequest = request => request?.isBilledToFacility;

export const readBilledToFacilityFromState = state => state.infobox.isBilledToFacility;

export const readBillerVerificationFromRequest = request => ({
  isBillerVerified: request?.isBillerVerified,
  billerVerifiedAt: request?.billerVerifiedAt,
  billerVerifiedBy: formatBillerVerifiedBy(request),
});

export const readBillerVerificationFromState = state => ({
  isBillerVerified: state.requests.isBillerVerified,
  billerVerifiedAt: state.requests.billerVerifiedAt,
  billerVerifiedBy: state.requests.billerVerifiedBy,
});
